var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,82.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141 693 c-31 -38 -33 -55 -29 -207 3 -154 12 -172 93 -198 35 -11 40 -17 43 -45 4 -41 5 -41 61 4 45 38 45 38 181 38 210 0 232 23 228 235 -5 210 11 200 -303 200 -254 0 -254 0 -274 -27z m328 -27 c62 -33 69 -112 13 -165 -21 -20 -41 -44 -45 -53 -4 -10 -11 -18 -17 -18 -5 0 -1 -9 10 -20 24 -24 25 -34 4 -54 -20 -20 -38 -20 -58 0 -21 20 -20 30 3 53 16 16 17 20 5 25 -30 11 -17 73 21 102 25 19 35 34 33 48 -4 29 -50 29 -63 -1 -17 -40 -75 -34 -75 8 0 70 96 112 169 75z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,82.000000) scale(0.100000,-0.100000)",
    fill: "#D6E4F5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138 703 c-33 -38 -38 -64 -38 -193 0 -178 16 -211 113 -234 24 -6 27 -11 27 -46 0 -49 3 -49 61 0 48 40 48 40 176 40 220 1 253 31 253 240 0 126 -10 172 -46 200 -13 11 -11 5 6 -20 35 -50 43 -286 11 -337 -38 -61 -60 -68 -211 -68 -136 0 -136 0 -181 -37 -56 -46 -57 -46 -61 -5 -3 28 -8 34 -43 45 -82 27 -90 43 -93 210 -3 144 -3 148 22 185 27 40 29 48 4 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 664 c-47 -25 -65 -84 -32 -102 24 -13 48 -4 59 21 13 30 59 30 63 1 2 -14 -8 -29 -33 -48 -38 -29 -51 -91 -21 -102 12 -5 11 -9 -5 -25 -23 -23 -24 -33 -3 -53 20 -20 38 -20 58 0 21 20 20 30 -4 54 -11 11 -15 20 -10 20 6 0 13 8 17 18 4 9 24 33 45 53 98 92 -14 228 -134 163z m133 -23 c41 -42 39 -83 -6 -128 -20 -20 -40 -44 -46 -54 -16 -31 -49 -24 -49 10 0 30 16 53 51 71 23 13 25 52 4 70 -20 17 -62 5 -70 -20 -9 -28 -55 -28 -55 1 0 37 53 79 100 79 33 0 48 -6 71 -29z m-47 -247 c7 -19 -10 -44 -29 -44 -19 0 -36 25 -29 44 3 9 16 16 29 16 13 0 26 -7 29 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 505 c0 -77 2 -107 3 -67 2 40 2 103 0 140 -2 37 -3 4 -3 -73z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,82.000000) scale(0.100000,-0.100000)",
    fill: "#2F7ED2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339 641 c-37 -37 -39 -71 -5 -71 16 0 27 7 31 20 8 25 50 37 70 20 21 -18 19 -57 -4 -70 -35 -18 -51 -41 -51 -71 0 -34 33 -41 49 -10 6 10 26 34 46 54 66 66 28 157 -65 157 -33 0 -48 -6 -71 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774 510 c0 -80 2 -112 3 -72 2 39 2 105 0 145 -1 39 -3 7 -3 -73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 510 c0 -69 1 -97 3 -62 2 34 2 90 0 125 -2 34 -3 6 -3 -63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 394 c-7 -19 10 -44 29 -44 19 0 36 25 29 44 -3 9 -16 16 -29 16 -13 0 -26 -7 -29 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 223 c37 -2 97 -2 135 0 37 2 6 3 -68 3 -74 0 -105 -1 -67 -3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,82.000000) scale(0.100000,-0.100000)",
    fill: "#0C254C",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 693 c-18 -37 -26 -274 -11 -331 14 -52 52 -97 102 -123 37 -19 39 -22 39 -68 0 -68 14 -68 100 0 73 59 73 59 209 59 228 0 261 34 261 273 0 170 -12 217 -54 217 -25 0 -25 0 -5 -35 19 -31 20 -48 17 -184 -3 -151 -3 -151 -41 -188 -37 -38 -37 -38 -184 -41 -146 -4 -146 -4 -202 -49 -56 -46 -56 -46 -65 0 -8 38 -13 46 -36 51 -41 8 -88 53 -100 94 -20 75 -13 253 14 305 23 47 23 47 -4 47 -19 0 -31 -8 -40 -27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/qa.217f1c409b5b906d961d257bfa77416b.svg";
export { ForwardRef as ReactComponent };